'use client';

import { ReactNode } from 'react';

import { normalizeSelect } from '@lib/server';
import type { BookingType, VenueBookingType, WidgetMapKeys } from '@types';

import { useGlobal } from '@/lib/global-store';

import { ScrollArea } from '../scroll-area';
import { Tabs } from '../tabs';
import { TabContent } from './tab-content';

export interface BookingJourneyProps {
  bookingTypes: (BookingType | VenueBookingType)[];
  bookingComponents: Record<WidgetMapKeys, ReactNode>;
}

export const BookingJourney = ({ bookingTypes, bookingComponents }: BookingJourneyProps) => {
  const { bookTab, setBookTab } = useGlobal();

  if (bookingTypes?.length === 1) {
    return (
      <ScrollArea className={'-mx-4 w-[calc(100%+2rem)] max-w-lg grow overflow-y-auto px-4'}>
        <TabContent {...bookingTypes[0]}>
          {bookingComponents[normalizeSelect(bookingTypes[0].component, true) as WidgetMapKeys]}
        </TabContent>
      </ScrollArea>
    );
  }

  return (
    // negative margin to push the scroll bar to the edge of the sheet
    <ScrollArea className="-mx-4 w-[calc(100%+2rem)] max-w-lg grow overflow-y-auto px-4">
      <Tabs
        value={bookTab}
        classNames={{
          list: 'w-full max-w-none backdrop-blur-md',
        }}
        onValueChange={setBookTab as (value: string) => void}
        items={bookingTypes.map(({ title, component, ...type }) => ({
          title,
          value: normalizeSelect(component, true) as WidgetMapKeys,
          content: (
            <TabContent {...type}>{bookingComponents[normalizeSelect(component, true) as WidgetMapKeys]}</TabContent>
          ),
        }))}
      />
    </ScrollArea>
  );
};
